var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSgSingapore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23013)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.875 0H-5.625V45H61.875V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.875 0H-5.625V22.5H61.875V0Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3125 3.76864C48.0884 4.15027 49.6788 5.13124 50.8169 6.54685C51.9549 7.96246 52.5713 9.72651 52.5625 11.5428C52.5537 13.3592 51.9203 15.1172 50.7685 16.5217C49.6168 17.9262 48.017 18.8917 46.2375 19.2561C47.2569 19.5511 48.3245 19.6419 49.3791 19.5234C50.4336 19.4049 51.4544 19.0794 52.3829 18.5655C53.3113 18.0516 54.1292 17.3595 54.7896 16.5288C55.45 15.6982 55.9399 14.7453 56.2313 13.7249C56.8099 11.6737 56.5529 9.47688 55.5164 7.61469C54.4799 5.75249 52.7483 4.37644 50.7 3.78739C49.2 3.35614 47.8125 3.34677 46.3032 3.76864H46.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5312 10.3123L47.0719 11.7186L48.2906 10.8561L49.4906 11.7373L49.05 10.3123L50.25 9.44043L48.7594 9.42168L48.2906 8.01543L47.8219 9.42168H46.3406L47.5312 10.3123ZM45.8906 15.1873L45.4219 16.6029L46.6406 15.7404L47.85 16.6123L47.4 15.1967L48.6 14.3154L47.1094 14.3061L46.65 12.8904L46.1813 14.2967H44.6813L45.8906 15.1873ZM40.4062 15.1498L39.9469 16.5748L41.1656 15.7029L42.3656 16.5748L41.925 15.1592L43.125 14.2873L41.6344 14.2686L41.1656 12.8623L40.6969 14.2686H39.2156L40.4062 15.1498ZM38.775 10.3123L38.3156 11.7279L39.5344 10.8654L40.7344 11.7373L40.2844 10.3217L41.4938 9.44043L39.9938 9.43105L39.5438 8.01543L39.075 9.42168H37.575L38.775 10.3123ZM43.1156 7.09668L42.6469 8.52168L43.8656 7.6498L45.075 8.53105L44.625 7.10605L45.825 6.2248L44.3438 6.21543L43.875 4.7998L43.4062 6.20605H41.9062L43.1156 7.09668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgSingapore);
export default __webpack_public_path__ + "static/media/sg Singapore.e1288869e97b16f3de02784e72464c71.svg";
export { ForwardRef as ReactComponent };